// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1JX_V","clinicsSelect":"TableHeading_clinicsSelect__g4_bb"};